<app-header></app-header>
<div class="wrapper">
  <div class="section_wrapper" style="margin-top: 96px; padding-bottom: 0px">
    <div class="sign_in_box">
      <h6 class="font_40_a32">Login</h6>
      <p class="font_20_a32_700">
        Log in below to continue your listing and see your savings.
      </p>
      <form class="example-form input" [formGroup]="form">
        <div class="form">
          <p style="color: red" *ngIf="isLoginFailed">
            * Invalid Email or Password
          </p>
          <div class="w-100">
            <mat-form-field class="genericTextFiled w_100">
              <mat-label>Email</mat-label>
              <input (keydown.enter)="transferFocus($event)" matInput type="text" placeholder="" name="Email"
                formControlName="email" />
            </mat-form-field>
            <mat-error *ngIf="
              (form.get('email').hasError('required') || 
                form.get('email').hasError('email')) &&
              submitted
            ">
              Please enter a valid email address</mat-error>
          </div>
          <div class="w-100">
            <mat-form-field appearance="fill" class="genericTextFiled w_100">
              <mat-label>Enter your password</mat-label>
              <input #input2 matInput [type]="hide ? 'password' : 'text'" formControlName="password" />
              <app-icon-button *ngIf="hide" matSuffix [margin]="'0 5px 0 0'" (click)="changepasswordIcon()">
                <img src="../../../assets/icons/show_eyes_icon.svg" alt="" />
              </app-icon-button>
              <app-icon-button *ngIf="!hide" matSuffix [margin]="'0 5px 0 0'" (click)="changepasswordIcon()">
                <img src=" ../../../assets/icons/hide_eye_icon.svg" alt="" />
              </app-icon-button>
              <!-- <button class="show_hide_btn" mat-icon-button  >
              </button> -->
            </mat-form-field>
            <mat-error class="error-message" *ngIf="form.get('password').hasError('required') && submitted">Please enter
              your password</mat-error>
          </div>
        </div>
        <p class="forgot_pass">
          <a (click)="forgotPassword()" class="">Forgot password?</a>
        </p>
        <div class="login">
          <!-- <button class="login_btn green_btn" *ngIf="!isLoader">LOGIN
          <img src="../../../assets/icons/arrow_white.svg" alt="">
          </button> -->
          <app-green-button-v2 [buttonType]="'submit'" (click)="onSubmit()" *ngIf="!isLoader" label="Login"
            [width]="'218px'" [height]="'60px'">
            <img class="after" src="../../../assets/icons/arrow_white.svg" alt="arrow_white"
              style="margin-left: 10px" />
          </app-green-button-v2>
          <app-loader *ngIf="isLoader"></app-loader>

          <!-- <button
            *ngIf="
              this.appState?.companyInfoValue?.awsCognitoConfig
                .enableAppleSignIn
            "
            class="social-button"
            title="Apple"
            (click)="logInWithIDP('SignInWithApple')"
          >
            Continue with Apple
          </button> -->
          <app-outlined-green-button *ngIf="
              this.appState?.companyInfoValue?.awsCognitoConfig
                ?.enableAppleSignIn
            " (click)="logInWithIDP('SignInWithApple')" label="Continue with Apple" [width]="'218px'" [height]="'60px'"
            [styles]="{ borderColor: '#d4d4d4' }">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" class="before">
              <path
                d="M18.52 8.23c-.1.09-2 1.18-2 3.62 0 2.82 2.4 3.82 2.48 3.84-.01.06-.38 1.37-1.27 2.7-.78 1.17-1.6 2.34-2.86 2.34-1.25 0-1.58-.75-3.02-.75-1.41 0-1.91.77-3.06.77-1.15 0-1.95-1.08-2.86-2.41A11.9 11.9 0 0 1 4 12.04C4 8.36 6.33 6.4 8.62 6.4c1.22 0 2.23.82 3 .82.73 0 1.86-.87 3.25-.87.52 0 2.4.05 3.65 1.88zm-4.31-3.45c.57-.7.98-1.67.98-2.65 0-.13-.01-.27-.04-.38-.93.04-2.04.64-2.7 1.44a4.2 4.2 0 0 0-1.02 2.58c0 .15.02.3.03.34.06.01.16.03.25.03.84 0 1.9-.58 2.5-1.36z"
                fill="#d5d5d5"></path>
            </svg>
          </app-outlined-green-button>
        </div>

        <p class="no_acct">
          <span>Don't have an account? </span>
          <a style="cursor: pointer" (click)="signUp()" class="green_transparent_btn">Sign up
          </a>
        </p>
      </form>
    </div>
  </div>
</div>
<app-footer></app-footer>